"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiCoverageInput = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var formik_1 = require("formik");
var compact_1 = __importDefault(require("lodash/compact"));
var get_1 = __importDefault(require("lodash/get"));
var react_1 = __importStar(require("react"));
var definitions_1 = require("../../hooks/definitions");
var line_of_coverage_type_option_1 = require("../../utils/line-of-coverage-type-option");
var coverage_input_1 = require("../coverage-input");
var lines_of_coverage_by_policy_type_input_1 = require("../lines-of-coverage-by-policy-type-input");
var helpers_1 = require("./helpers");
function propertyKey(rootPropertyName, propertyName) {
    return rootPropertyName + "." + propertyName;
}
function MultiCoverageInput(_a) {
    var _b = _a.name, name = _b === void 0 ? 'multiCoverage' : _b, enableAdditions = _a.enableAdditions, disableRepeated = _a.disableRepeated;
    var _c = formik_1.useFormikContext(), values = _c.values, setFieldValue = _c.setFieldValue;
    var _d = react_1.useState(), selectedOptions = _d[0], setSelectedOptions = _d[1];
    var renderLineOfCoverageType = definitions_1.useDefinitionsHelpers().renderLineOfCoverageType;
    function setPolicyTypeAndOptions(policyType, newSelectedOptions) {
        var items = get_1.default(values, propertyKey(name, 'coverages'), []);
        var sortedNewSelectedOptions = line_of_coverage_type_option_1.sortOptions(newSelectedOptions);
        var currentIds = (selectedOptions !== null && selectedOptions !== void 0 ? selectedOptions : newSelectedOptions).map(function (_a) {
            var id = _a.id;
            return id;
        });
        var enhancedItems = helpers_1.enhanceValueItems(items, currentIds, sortedNewSelectedOptions);
        var newValue = {
            policyType: policyType,
            coverages: enhancedItems.map(function (_a) {
                var valueItem = _a.valueItem;
                return valueItem;
            }),
        };
        setSelectedOptions(sortedNewSelectedOptions);
        setFieldValue(name, newValue);
    }
    // on mount, set the initial selected options
    react_1.useEffect(function () {
        var initialValues = get_1.default(values, name);
        if (!initialValues || !initialValues.policyType)
            return;
        var policyType = initialValues.policyType, _a = initialValues.coverages, coverages = _a === void 0 ? [] : _a;
        var types = compact_1.default(coverages.map(function (_a) {
            var type = _a.type;
            return type;
        }));
        var initialSelectedOptions = line_of_coverage_type_option_1.typesToOptions(types);
        setPolicyTypeAndOptions(policyType, initialSelectedOptions);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(core_ui_1.Stack, { gap: 16, direction: "vertical" },
        react_1.default.createElement(lines_of_coverage_by_policy_type_input_1.LinesOfCoverageByPolicyTypeInput, { enableAdditions: enableAdditions, disableRepeated: disableRepeated, values: {
                policyType: get_1.default(values, propertyKey(name, 'policyType')),
                selectedOptions: selectedOptions,
            }, onChange: setPolicyTypeAndOptions }),
        (selectedOptions !== null && selectedOptions !== void 0 ? selectedOptions : []).length > 0 && (react_1.default.createElement(core_ui_1.Stack, { gap: 8, direction: "vertical" },
            react_1.default.createElement(core_ui_1.Text, { color: "dark", weight: 700 }, "Line of coverage details"),
            (selectedOptions !== null && selectedOptions !== void 0 ? selectedOptions : []).map(function (option, index) { return (react_1.default.createElement(core_ui_1.ExpandableRow, { key: option.id + "-expandable-row", expanded: true },
                react_1.default.createElement(core_ui_1.ExpandableHead, null,
                    react_1.default.createElement(core_ui_1.Text, null, line_of_coverage_type_option_1.getOptionLabel(option, renderLineOfCoverageType))),
                react_1.default.createElement(core_ui_1.ExpandableBody, null,
                    react_1.default.createElement(coverage_input_1.CoverageInput, { name: propertyKey(name, 'coverages') + "[" + [index] + "]", lineOfCoverageType: option.type })))); })))));
}
exports.MultiCoverageInput = MultiCoverageInput;
